import {booleanAttribute, Component, input} from '@angular/core';

@Component({
  selector: 'stack',
  imports: [],
  templateUrl: './stack.component.html',
  styleUrl: './stack.component.css',
  host: {
    // '[class.app-rounded]': 'rounded()',
    '[class.horizontal]': 'direction() === "horizontal"',
    '[class.transparent]': 'transparent()',
  }
})
export class StackComponent {
  readonly direction = input<'vertical' | 'horizontal'>('vertical');
  // readonly rounded = input(false, { transform: booleanAttribute });
  readonly transparent = input(false, { transform: booleanAttribute });
}
